module.exports = (require("./helpers/browser/html-loader")(new __parcel__URL__(require('./helpers/bundle-manifest').resolve("3KD8J")).toString()));